export default "__VITE_ASSET__2c521ca7__"